import React, { useMemo, useState } from 'react'

import { Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import Cargando from '../Cargando';
import IconCloseModal from './IconCloseModal';


export type PropsModalConfirmacion = {
    idModal?: string,
    backdrop?: boolean,
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    asyncAccion: boolean,
    asyncClose: boolean,
    onClose: () => void,
    asyncAfterOnClose?: () => Promise<void>,
    onClick?: () => void,
    asyncOnClick?: () => Promise<number>;
    mensajeConfirmacion: string,
    classNamemensajeConfirmacion?: string,
    classNameContentModal?: string,
    classNameAllModal?: string
    nombreBotonAccion: string,
    disabledBotonAccion?: boolean,
    classNameBotonAccion?: string,
    nombreBotonCerrarModal?: string,
    nombreBotonAfterOnClose?: string,
    closeAfterAccion: boolean
    hideBotonCerrar: boolean,
    contentModal?: HTMLElement | React.ReactElement
    tituloModal?: string,
    classNametituloModal?: string,
    showTituloModal?: boolean,
    botonesAccionParteSuperior?: boolean,
    centered?: boolean,
    classNameBotonCerrarModal?: React.CSSProperties,
    classNameBotonCerrarModal2?: string,
    classNameContainer?: string,
    colorButtonAccion?: string,
    invertOrderButton?: boolean,
    noModalHeader?: boolean,
    useContainer?: boolean
    
}

type StateModalConfirmacion = {
    realizandoAccion: boolean,
    accionTerminada: boolean,
    errorAsyncAccion: boolean
}

export default function ModalConfirmacion(props: PropsModalConfirmacion) {

    const initialState: StateModalConfirmacion = {
        realizandoAccion: false,
        accionTerminada: false,
        errorAsyncAccion: false,
    }

    const [stateModal, setstateModal] = useState<StateModalConfirmacion>(initialState);

    function CerrarModal() {
        setstateModal(initialState);
        props.onClose();
        document.body.classList.remove('modal-open')
    }

    async function CerrarModalAndAfterClose(callbackClose: () => Promise<void>) {
        setstateModal(initialState);
        await callbackClose();

    }

    async function AccionAsync(callbackAccion: () => Promise<number>) {
        const { asyncAfterOnClose } = props;
        setstateModal({ ...stateModal, realizandoAccion: true })
        var statusAccion = await callbackAccion();

        if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "function") {
            await CerrarModalAndAfterClose(asyncAfterOnClose);
        }
        else if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "undefined") {
            CerrarModal();
        }

        else {
            if (statusAccion > -1) {
                setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true })
            }
            else {
                setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true, errorAsyncAccion: true })
            }
        }

    }

    function AccionNotAsync(callbackAccion: () => void) {

        const { closeAfterAccion } = props;
        callbackAccion();

        if (closeAfterAccion) {
            CerrarModal();
        }
    }

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal handleClickIcon={() => CerrarModal()} />
        )
    }, [props])


    const BotonCancelar = useMemo(() => {
        return (
            <Button className={`${props.classNameBotonCerrarModal2 ?? ""}`} color="secondary" disabled={stateModal.realizandoAccion} onClick={() => CerrarModal()}> {props.nombreBotonCerrarModal !== undefined ? props.nombreBotonCerrarModal : "Cerrar Mensaje"} </Button>
        )
    }, [stateModal, props])

    const BotonAccion = useMemo(() => {
        const { asyncOnClick, onClick } = props;

        const colorButton = props.colorButtonAccion ? props.colorButtonAccion : "primary"

        if (props.asyncAccion && asyncOnClick) {
            return (
                <Button disabled={props.disabledBotonAccion ?? false} color={colorButton} className={`mr-2 ${props.classNameBotonAccion ?? ""}`} onClick={async () => await AccionAsync(asyncOnClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else if (!props.asyncAccion && onClick) {
            return (
                <Button disabled={props.disabledBotonAccion ?? false} color={colorButton} className={`mr-2 ${props.classNameBotonAccion ?? ""}`} onClick={() => AccionNotAsync(onClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else {
            return (<div></div>)
        }


    }, [props, stateModal])

    const BotonCerrarYAccion = useMemo(() => {
        const { asyncAfterOnClose, nombreBotonAfterOnClose } = props

        if (asyncAfterOnClose && nombreBotonAfterOnClose) {
            return (
                <Button color="primary" id="botonAfterOnClose" className="mr-2" onClick={async () => await CerrarModalAndAfterClose(asyncAfterOnClose)}>{nombreBotonAfterOnClose ?? "Cerrar y Continuar"}</Button>
            )
        }
    }, [props, stateModal])

    const ContenidoModal = useMemo(() => {
        const { accionTerminada, realizandoAccion, errorAsyncAccion } = stateModal;
        const { asyncClose, invertOrderButton } = props;



        const botonesAcciones = (
            <>
                {
                    invertOrderButton !== undefined && invertOrderButton && (
                        <>
                            {!props.hideBotonCerrar && !realizandoAccion && BotonCancelar}
                            {!realizandoAccion && !accionTerminada && BotonAccion}
                            {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && BotonCerrarYAccion}
                        </>

                    )
                }
                {
                    invertOrderButton === undefined && (
                        <>
                            {!realizandoAccion && !accionTerminada && BotonAccion}
                            {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && BotonCerrarYAccion}
                            {!props.hideBotonCerrar && !realizandoAccion && BotonCancelar}
                        </>

                    )
                }

            </>
        )




        var parteinicial = (
            <>
                {
                    !realizandoAccion && !accionTerminada && props.mensajeConfirmacion &&
                    <Row className="justify-content-center">
                        <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                    </Row>
                }
            </>




        )

        if (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === true) {
            parteinicial = (
                <Row className="justify-content-start">
                    {
                        !realizandoAccion && !accionTerminada &&
                        <Col xl={8} lg={8} md={12}>
                            <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                        </Col>
                    }

                    {!realizandoAccion && !accionTerminada && <Col xl={1} lg={1} md={6}>{BotonAccion}</Col>}
                    {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && <Col xl={1} lg={1} md={6} className="d-flex ">{BotonCerrarYAccion}</Col>}
                    {!props.hideBotonCerrar && !realizandoAccion && <Col xl={1} lg={1} md={6} className="d-flex ">{BotonCancelar}</Col>}

                </Row>
            );
        }

        const contenido = (
            <>
                {
                    parteinicial
                }
                {

                    props.contentModal
                }


                <Row className="justify-content-center rowConBtnModalConf" style={props.classNameBotonCerrarModal}>
                    {
                        (props.botonesAccionParteSuperior === undefined || (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === false))
                        && botonesAcciones
                    }



                </Row>
                <Row>
                    <Col>
                        {
                            realizandoAccion && !accionTerminada &&
                            <Row className="justify-content-center">
                                <Cargando />
                            </Row>
                        }
                    </Col>

                </Row>
                <Row className="justify-content-center">
                    <Col>
                        {
                            !realizandoAccion && accionTerminada && !errorAsyncAccion &&
                            <p className='error-small'>Se ha completado la acción</p>
                        }
                        {
                            !realizandoAccion && accionTerminada && errorAsyncAccion &&
                            <p className='error-small'>Ha ocurrido un inconveniente al tratar de realizar la acción</p>
                        }
                    </Col>
                </Row>
            </>
        )


        if (props.useContainer && props.useContainer === true) {
            return (
                <Container className = {props.classNameContainer}>
                    {contenido}
                </Container>
            )
        }
        else {
            return (
                <>
                    {contenido}
                </>
            )
        }

    }, [props, stateModal])



    return (
        <Modal
            id={props.idModal ?? "uniqueIdModal" + props.nombreBotonAccion}
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={props.centered !== undefined ? props.centered : false}
            onClosed={() => CerrarModal()}
            contentClassName={(props.classNameAllModal ?? "custom-modal-style") === "default" ? "" : props.classNameAllModal}
            backdrop={props.backdrop !== undefined ? props.backdrop : true}
            keyboard={true}
        >
            {
                props.noModalHeader !== undefined && props.noModalHeader === true ?
                    <>
                    </>
                    :
                    <ModalHeader close={BotonCerrar}>
                        {
                            props.showTituloModal === undefined ||
                                props.showTituloModal === true ?
                                <div className={`${props.classNametituloModal ?? 'tituloModalDocumentos'}`}>{props.tituloModal ? props.tituloModal : props.tituloModal === "" ? "" : "Mensaje de confirmación"}</div>
                                :
                                <div />
                        }
                    </ModalHeader>
            }


            <ModalBody className={props.classNameContentModal ?? ""}>
                {ContenidoModal}
            </ModalBody>

        </Modal>
    )
}
